import { initDycolor } from '~';

initDycolor('fill-status', require(`${process.env.DYCOLOR_REQUIRE}./FillStatus.scss`)); // eslint-disable-line

export default {
  props: {
    title: String,
    checked: Boolean,
    hideChecked: {
      type: Boolean,
      default: false,
    },
    icon: String,
    edit: Boolean,
  },
  computed: {
    iconName() {
      return this.checked ? 'check' : 'close';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/fill-status/FillStatus.js